module.exports = __webpack_public_path__ + "static/media/2.70bac1c8.jpg";